(() => {
  const primary = 'img[data-gf-card-primary-srcset]';
  const mediaSelector = '[data-gf-card-media]';
  const secondarySelector = ':scope > img[data-gf-card-image="secondary"]';
  const hoverInput = matchMedia('(hover: hover) and (pointer: fine)');
  const prepared = new WeakSet();
  let active = null;
  const reset = () => {
    if (active) active.removeAttribute('data-gf-card-hover-active');
    active = null;
  };
  const load = (image, kind) => {
    const attr = 'data-gf-card-' + kind + '-';
    if (!image.hasAttribute(attr + 'srcset')) return;
    image.loading = 'eager';
    image.fetchPriority = kind === 'hover' ? 'low' : 'auto';
    image.srcset = image.getAttribute(attr + 'srcset');
    image.src = image.getAttribute(attr + 'src');
    image.removeAttribute(attr + 'srcset');
    image.removeAttribute(attr + 'src');
  };
  const prepare = image => {
    if (prepared.has(image)) return;
    prepared.add(image);
    const ready = async () => {
      if (!image.complete || !image.naturalWidth || !image.currentSrc || image.currentSrc.startsWith('data:')) return;
      try { if (image.decode) await image.decode(); } catch { return; }
      if (image.complete && image.naturalWidth) {
        image.setAttribute('data-gf-card-ready', '');
        image.removeEventListener('load', ready);
      }
    };
    image.addEventListener('load', ready);
    load(image, 'hover');
    ready();
  };
  const initialize = () => {
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        load(entry.target, 'primary');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '200px 0px', threshold: 0.01 }) : null;
    const observe = root => {
      if (root.nodeType !== 1) return;
      const images = [...root.querySelectorAll(primary)];
      if (root.matches(primary)) images.unshift(root);
      images.forEach(image => observer ? observer.observe(image) : load(image, 'primary'));
    };
    observe(document.body);
    new MutationObserver(records => {
      if (active && !active.isConnected) reset();
      records.forEach(record => record.addedNodes.forEach(observe));
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('pointerover', event => {
      if (!hoverInput.matches || event.pointerType !== 'mouse') { reset(); return; }
      const media = event.target.closest?.(mediaSelector);
      const image = media?.querySelector(secondarySelector);
      if (!image) return;
      if (active !== media) reset();
      active = media;
      media.setAttribute('data-gf-card-hover-active', '');
      prepare(image);
    }, { passive: true });
    document.addEventListener('pointerout', event => {
      if (active && !active.contains(event.relatedTarget)) reset();
    }, { passive: true });
    document.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse') reset();
    }, { passive: true });
    document.addEventListener('pointercancel', reset, { passive: true });
    document.addEventListener('visibilitychange', () => { if (document.hidden) reset(); });
    document.addEventListener('shopify:section:load', event => observe(event.target));
    hoverInput.addEventListener('change', reset);
    window.addEventListener('blur', reset);
    window.addEventListener('pagehide', reset);
    window.addEventListener('pageshow', reset);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
